import React, { useState } from 'react';
import { Sidebar } from '../../components/Sidebar';
import { Header } from '../../components/Header';
import { MetricCard } from '../../components/growth/MetricCard';
import { KPIGauge } from '../../components/growth/KPIGauge';
import { PlusIcon, UserPlusIcon, BellIcon, ArrowRightIcon, PieChartIcon, ActivityIcon, ShieldCheckIcon } from 'lucide-react';
import { RECENT_ACTIVITY } from '../../data/brandMockData';
import { CreateCampaignModal } from '../../components/brand/CreateCampaignModal';
import { OnboardPartnerModal } from '../../components/brand/OnboardPartnerModal';
export function BrandDashboard() {
  const [isCreateCampaignOpen, setIsCreateCampaignOpen] = useState(false);
  const [isOnboardPartnerOpen, setIsOnboardPartnerOpen] = useState(false);
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-1800">
      <Sidebar data-id="element-1801" />
      <main className="flex-1 overflow-y-auto" data-id="element-1802">
        <Header data-id="element-1803" />
        <div className="px-8 py-8" data-id="element-1804">
          <div className="flex items-center justify-between mb-8" data-id="element-1805">
            <div data-id="element-1806">
              <h1 className="text-2xl font-bold text-gray-900" data-id="element-1807">
                Executive Hub
              </h1>
              <p className="text-gray-500 mt-1" data-id="element-1808">
                Overview of network performance and brand health
              </p>
            </div>
            <div className="flex gap-3" data-id="element-1809">
              <button onClick={() => setIsOnboardPartnerOpen(true)} className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-1810">
                <UserPlusIcon size={16} data-id="element-1811" />
                Onboard Partner
              </button>
              <button onClick={() => setIsCreateCampaignOpen(true)} className="flex items-center gap-2 px-4 py-2 bg-blue-600 rounded-lg text-sm font-medium text-white hover:bg-blue-700 shadow-sm" data-id="element-1812">
                <PlusIcon size={16} data-id="element-1813" />
                Create Campaign
              </button>
            </div>
          </div>

          {/* KPI Cards */}
          <div className="grid grid-cols-5 gap-4 mb-8" data-id="element-1814">
            <MetricCard label="Total Leads" value="101.85K" change={12.5} data-id="element-1815" />
            <MetricCard label="Total Spend" value="₹11.25M" change={8.2} data-id="element-1816" />
            <MetricCard label="Network ROI" value="3.2x" change={-1.5} data-id="element-1817" />
            <MetricCard label="Avg CPL" value="₹110" change={-2.4} inverse data-id="element-1818" />
            <MetricCard label="Compliance" value="87%" change={4.1} data-id="element-1819" />
          </div>

          <div className="grid grid-cols-3 gap-6 mb-8" data-id="element-1820">
            {/* Partner Health */}
            <div className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm" data-id="element-1821">
              <div className="flex items-center justify-between mb-6" data-id="element-1822">
                <h2 className="text-lg font-semibold text-gray-900" data-id="element-1823">
                  Partner Health
                </h2>
                <ActivityIcon className="text-gray-400" size={20} data-id="element-1824" />
              </div>
              <div className="flex items-center justify-center mb-6" data-id="element-1825">
                <div className="relative w-48 h-48" data-id="element-1826">
                  <svg className="w-full h-full transform -rotate-90" data-id="element-1827">
                    <circle cx="96" cy="96" r="88" stroke="#f3f4f6" strokeWidth="16" fill="none" data-id="element-1828" />
                    <circle cx="96" cy="96" r="88" stroke="#10b981" strokeWidth="16" fill="none" strokeDasharray={2 * Math.PI * 88} strokeDashoffset={2 * Math.PI * 88 * (1 - 0.78)} className="transition-all duration-1000 ease-out" data-id="element-1829" />
                  </svg>
                  <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-1830">
                    <span className="text-4xl font-bold text-gray-900" data-id="element-1831">
                      78%
                    </span>
                    <span className="text-sm text-gray-500" data-id="element-1832">Healthy</span>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-2 text-center text-sm" data-id="element-1833">
                <div className="p-2 bg-green-50 rounded-lg" data-id="element-1834">
                  <div className="font-bold text-green-700" data-id="element-1835">32</div>
                  <div className="text-green-600 text-xs" data-id="element-1836">Healthy</div>
                </div>
                <div className="p-2 bg-amber-50 rounded-lg" data-id="element-1837">
                  <div className="font-bold text-amber-700" data-id="element-1838">8</div>
                  <div className="text-amber-600 text-xs" data-id="element-1839">At Risk</div>
                </div>
                <div className="p-2 bg-red-50 rounded-lg" data-id="element-1840">
                  <div className="font-bold text-red-700" data-id="element-1841">2</div>
                  <div className="text-red-600 text-xs" data-id="element-1842">Critical</div>
                </div>
              </div>
            </div>

            {/* Compliance Status */}
            <div className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm" data-id="element-1843">
              <div className="flex items-center justify-between mb-6" data-id="element-1844">
                <h2 className="text-lg font-semibold text-gray-900" data-id="element-1845">
                  Compliance Status
                </h2>
                <ShieldCheckIcon className="text-gray-400" size={20} data-id="element-1846" />
              </div>
              <div className="space-y-6" data-id="element-1847">
                <div data-id="element-1848">
                  <div className="flex justify-between text-sm mb-2" data-id="element-1849">
                    <span className="text-gray-600" data-id="element-1850">Brand Identity</span>
                    <span className="font-medium text-gray-900" data-id="element-1851">94%</span>
                  </div>
                  <div className="w-full bg-gray-100 rounded-full h-2" data-id="element-1852">
                    <div className="bg-blue-500 h-2 rounded-full" style={{
                    width: '94%'
                  }} data-id="element-1853"></div>
                  </div>
                </div>
                <div data-id="element-1854">
                  <div className="flex justify-between text-sm mb-2" data-id="element-1855">
                    <span className="text-gray-600" data-id="element-1856">Pricing & Offers</span>
                    <span className="font-medium text-gray-900" data-id="element-1857">82%</span>
                  </div>
                  <div className="w-full bg-gray-100 rounded-full h-2" data-id="element-1858">
                    <div className="bg-amber-500 h-2 rounded-full" style={{
                    width: '82%'
                  }} data-id="element-1859"></div>
                  </div>
                </div>
                <div data-id="element-1860">
                  <div className="flex justify-between text-sm mb-2" data-id="element-1861">
                    <span className="text-gray-600" data-id="element-1862">Creative Guidelines</span>
                    <span className="font-medium text-gray-900" data-id="element-1863">88%</span>
                  </div>
                  <div className="w-full bg-gray-100 rounded-full h-2" data-id="element-1864">
                    <div className="bg-green-500 h-2 rounded-full" style={{
                    width: '88%'
                  }} data-id="element-1865"></div>
                  </div>
                </div>

                <div className="pt-4 border-t border-gray-100 flex items-center justify-between" data-id="element-1866">
                  <div data-id="element-1867">
                    <div className="text-2xl font-bold text-gray-900" data-id="element-1868">12</div>
                    <div className="text-xs text-gray-500" data-id="element-1869">
                      Active Violations
                    </div>
                  </div>
                  <button className="text-sm text-blue-600 font-medium hover:text-blue-700" data-id="element-1870">
                    View All
                  </button>
                </div>
              </div>
            </div>

            {/* Campaign Status */}
            <div className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm" data-id="element-1871">
              <div className="flex items-center justify-between mb-6" data-id="element-1872">
                <h2 className="text-lg font-semibold text-gray-900" data-id="element-1873">
                  Campaign Status
                </h2>
                <PieChartIcon className="text-gray-400" size={20} data-id="element-1874" />
              </div>
              <div className="flex items-center gap-8" data-id="element-1875">
                <div className="relative w-32 h-32" data-id="element-1876">
                  <svg className="w-full h-full transform -rotate-90" data-id="element-1877">
                    <circle cx="64" cy="64" r="32" stroke="transparent" strokeWidth="32" fill="none" data-id="element-1878" />
                    {/* Active - 45% */}
                    <circle cx="64" cy="64" r="32" stroke="#3b82f6" strokeWidth="32" fill="none" strokeDasharray={`${2 * Math.PI * 32 * 0.45} ${2 * Math.PI * 32 * 0.55}`} strokeDashoffset="0" data-id="element-1879" />
                    {/* Paused - 25% */}
                    <circle cx="64" cy="64" r="32" stroke="#f59e0b" strokeWidth="32" fill="none" strokeDasharray={`${2 * Math.PI * 32 * 0.25} ${2 * Math.PI * 32 * 0.75}`} strokeDashoffset={`-${2 * Math.PI * 32 * 0.45}`} data-id="element-1880" />
                    {/* Completed - 30% */}
                    <circle cx="64" cy="64" r="32" stroke="#10b981" strokeWidth="32" fill="none" strokeDasharray={`${2 * Math.PI * 32 * 0.3} ${2 * Math.PI * 32 * 0.7}`} strokeDashoffset={`-${2 * Math.PI * 32 * 0.7}`} data-id="element-1881" />
                  </svg>
                </div>
                <div className="space-y-3" data-id="element-1882">
                  <div className="flex items-center gap-2" data-id="element-1883">
                    <div className="w-3 h-3 rounded-full bg-blue-500" data-id="element-1884"></div>
                    <span className="text-sm text-gray-600" data-id="element-1885">Active (24)</span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-1886">
                    <div className="w-3 h-3 rounded-full bg-amber-500" data-id="element-1887"></div>
                    <span className="text-sm text-gray-600" data-id="element-1888">Paused (13)</span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-1889">
                    <div className="w-3 h-3 rounded-full bg-green-500" data-id="element-1890"></div>
                    <span className="text-sm text-gray-600" data-id="element-1891">
                      Completed (16)
                    </span>
                  </div>
                </div>
              </div>
              <div className="mt-6 pt-4 border-t border-gray-100" data-id="element-1892">
                <div className="flex justify-between items-center" data-id="element-1893">
                  <span className="text-sm text-gray-500" data-id="element-1894">
                    Total Budget Utilized
                  </span>
                  <span className="text-sm font-bold text-gray-900" data-id="element-1895">68%</span>
                </div>
                <div className="w-full bg-gray-100 rounded-full h-1.5 mt-2" data-id="element-1896">
                  <div className="bg-blue-600 h-1.5 rounded-full" style={{
                  width: '68%'
                }} data-id="element-1897"></div>
                </div>
              </div>
            </div>
          </div>

          {/* Recent Activity */}
          <div className="bg-white rounded-xl border border-gray-200 shadow-sm" data-id="element-1898">
            <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between" data-id="element-1899">
              <h2 className="text-lg font-semibold text-gray-900" data-id="element-1900">
                Recent Activity
              </h2>
              <button className="text-sm text-blue-600 font-medium hover:text-blue-700 flex items-center gap-1" data-id="element-1901">
                View All <ArrowRightIcon size={16} data-id="element-1902" />
              </button>
            </div>
            <div className="divide-y divide-gray-100" data-id="element-1903">
              {RECENT_ACTIVITY.map(activity => {
              const Icon = activity.icon;
              return <div key={activity.id} className="px-6 py-4 flex items-center gap-4 hover:bg-gray-50 transition-colors" data-id="element-1904">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${activity.color}`} data-id="element-1905">
                      <Icon size={20} data-id="element-1906" />
                    </div>
                    <div className="flex-1" data-id="element-1907">
                      <p className="text-sm text-gray-900" data-id="element-1908">
                        <span className="font-semibold" data-id="element-1909">{activity.user}</span>{' '}
                        {activity.action}{' '}
                        <span className="font-medium" data-id="element-1910">{activity.target}</span>
                      </p>
                      <p className="text-xs text-gray-500 mt-0.5" data-id="element-1911">
                        {activity.time}
                      </p>
                    </div>
                    <button className="text-gray-400 hover:text-gray-600" data-id="element-1912">
                      <ArrowRightIcon size={16} data-id="element-1913" />
                    </button>
                  </div>;
            })}
            </div>
          </div>
        </div>
      </main>

      <CreateCampaignModal isOpen={isCreateCampaignOpen} onClose={() => setIsCreateCampaignOpen(false)} data-id="element-1914" />
      <OnboardPartnerModal isOpen={isOnboardPartnerOpen} onClose={() => setIsOnboardPartnerOpen(false)} data-id="element-1915" />
    </div>;
}